// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"7d509776","144":"aacd40a1","213":"64b52d42","453":"0fb07ad0"}[chunkId] + ".chunk.js";
};